import Skeleton from '@carvana/ds-skeleton';
import { SebastianStatus } from '~/constants/common/SebastianStatus';
import { SebastianQuestion } from '~/context/common/SebastianContext';
import AskSomethingElse from './AskSomethingElse';
import { QuestionButton } from './SebastianQuestions.styles';

type QuestionsProps = {
  handleQuestionClick: (question?: SebastianQuestion) => void;
  questions: SebastianQuestion[];
  isLoaded: boolean;
  sebastianStatus: SebastianStatus;
};

export default function Questions({
  handleQuestionClick,
  questions,
  isLoaded,
  sebastianStatus
}: QuestionsProps) {
  const shouldShowSkeletons =
    !isLoaded || sebastianStatus !== SebastianStatus.Ready;

  if (shouldShowSkeletons) {
    return (
      <div className="flex flex-wrap gap-md">
        {Array.from({ length: 5 }).map((_, index) => (
          <Skeleton
            key={index}
            className="overflow-hidden rounded-full"
            data-testid="question-skeleton"
            height="36px"
            width="200px"
          />
        ))}
      </div>
    );
  }

  return (
    <div className="flex flex-wrap gap-md">
      {questions.map(question => (
        <QuestionButton
          key={question.id}
          aria-label={question.question}
          data-adobe-id={null}
          data-analytics-id={null}
          data-testid="sebastian-question"
          onClick={() => handleQuestionClick(question)}
          type="button"
        >
          {question.question}
        </QuestionButton>
      ))}

      <AskSomethingElse
        data-testid="sebastian-ask-something-else"
        onClick={() => {
          handleQuestionClick();
        }}
        sebastianStatus={sebastianStatus}
      />
    </div>
  );
}
